import { PageContextUtils, UrlUtils } from "../../../../utils";

import { config as defaultConfig } from "../../default/Kambi/Config.resource";

const getSportUrl = () => {
  return UrlUtils.getCurrentOriginURLWithLang(window.location.origin);
};

const { clientPage } = PageContextUtils.getSurveyData();

export const links = {
  bettingHistory: "/#/bethistory",
  bettingRules: "/how-to-bet/betting-terms/",
  blog: "/blog/",
  casinoUrl: "https://www.888casino.dk/",
  sportUrl: getSportUrl(),
  contactUs: "https://888-external-dk.custhelp.com/app/ask/p/881,884",
  help: "https://888-external-dk.custhelp.com/app/home/p/881,884",
  home: "/",
  liveChat:
    "https://888-external-dk.custhelp.com/app/chat/chat_launch?chanel=888dk_dk_norm&ChRefId=3",
  liveChatVIP:
    "https://888-external-dk.custhelp.com/app/chat/chat_launch?chanel=888dk_dk_vip&ChRefId=3",
  liveNow: "/live-betting/",
  logoTypesStopspillet: "https://www.stopspillet.dk/",
  logoTypesDga: "https://www.spillemyndigheden.dk/",
  logoTypesRofus: "https://www.rofus.nu/",
  logoTypesEighteenPlus: "https://www.888.dk/responsible-gaming/",
  logoTypesRegulation: "https://www.888.dk/responsible-gaming/",
  pokerUrl: "https://www.888poker.dk/",
  pokerUrlAuthenticated: "https://www.888poker.dk/open-client/",
  pokerNativeUrliOS:
    "https://poker-dk.onelink.me/Xpy8/CrossSellSportToPokeriOS",
  pokerNativeUrlAndroid:
    "https://poker-dk.onelink.me/Xpy8/CrossSellSportToPokerAndroid",
  promotions: "/promotions/",
  responsibleGaming: "https://www.888.dk/responsible-gaming/",
  startingSoon: "/starter-snart/",
  survey: clientPage,
  pokerHistoryLink: "/app/pokerhistorik/"
};

export const config = {
  ...defaultConfig,
  logo_VIP: "sport_logo_VIP"
};
